var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.cssClass},[_c('pvd-system-message',{attrs:{"id":`${_vm.idPrefix}Error`,"message":_vm.message,"placement":_vm.placement,"type":_vm.type}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }